export default __webpack_public_path__ + "static/websdk-sample-861565bcbb8d07e5f21e8721a62d53e6.png";